import Loader from '../Loader';
import { BoxProps } from '@mui/material';
import { Cell, Price, Root, Unit } from './PriceCellStyle';
import { parsePrice } from '@app/utils/price';

interface PriceCellProps extends BoxProps {
  amount: number | undefined;
  unit?: string;
  isLoading: boolean;
  showDecimal?: boolean;
}

function PriceCell({ amount, unit, isLoading, showDecimal, ...rest }: PriceCellProps) {
  const getParsedAmount = (amount: number | undefined) => {
    if (amount !== null && amount !== undefined) {
      const parsedValue: number | null = parsePrice(amount);
      if (parsedValue) {
        const parsedAmount = Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: showDecimal ? 2 : 0,
          maximumFractionDigits: showDecimal ? 2 : 0,
        }).format(parsedValue);
        return parsedAmount;
      } else {
        return null;
      }
    } else {
      return null;
    }
  };

  return (
    <Root {...rest}>
      <Cell>
        {isLoading ? (
          <Loader />
        ) : (
          <Price className='price-cell-typography'>{getParsedAmount(amount) ?? '$-'}</Price>
        )}
      </Cell>
      {unit && (
        <Unit className='price-cell-typography'>
          {' / '}
          {unit}
        </Unit>
      )}
    </Root>
  );
}

export default PriceCell;
